/* eslint-disable import/first */
<template>
  <div class="card w-full sm:max-w-xsm md:mr-4">
    <div class="flex flex-col w-full h-auto overflow-hidden rounded-lg shadow-md lg:shadow-lg xl:shadow-lg bg-white">
      <div class="relative  " :class="gameBanner">
        <div v-if="!event.media_banner.head" class="h-40 w-full -mt-10">
        </div>
        <div class="h-40" v-else>
          <img :src="event.media_banner.head" class=" w-full h-full">
        </div>
      </div>
      <div class="p-5 relative item">
        <div class="flex flex-col w-full ">
          <div class="flex flex-wrap justify-between">
            <h2 class="text-brand-light text-2xl flex justify-center items-center iphone-font-title" v-text="getEventDate[0]"></h2>
            <img class="flex justify-center items-center" src="@/assets//SVG/calendar.svg" alt="">
          </div>
          <div class="w-full bg-additional-text mt-1" style="height: 1px"></div>
          <div class="h-28 mb-1">
            <h2 class="text-2xl mb-2 iphone-font-title font-extrabold" v-text="getGameType"></h2>
            <p class="text-sm font-bold text-additional-text" v-text="getGameSmallTitle"></p>
          </div>
          <div class="flex flex-col text-sm h-25 bg-white">
            <div class="flex items-center">
              <img class="w-4 h-4" src="@/assets//SVG/watch.svg" alt="">
              <p class=" pl-4" v-text="'Начало в '+getEventTime"></p>
            </div>
            <div v-if="event.place" class="flex items-center mt-3 relative">
              <img class="w-4 h-4" src="@/assets//SVG/place.svg" alt="">
              <p class=" pl-4 truncate inline cursor-default"
                 v-text="event.place" @click="showPopUp('place')"
                 :class="{'popOnClickMobile': showPlacePopUp}"></p>
              <div v-if="event.address.length > 35"
                   class="absolute -mx-2 pin-t pin-l p-2 bg-white z-10 hidden cursor-default popOnHover shadow-lg rounded">
                <img class="w-4 h-4" src="@/assets//SVG/place.svg" alt="">
                <p class="pl-4" v-text="event.place"></p>
              </div>
            </div>
            <div v-if="event.address" class="flex items-center mt-3 relative">
              <img class="w-4 h-4" src="@/assets//SVG/address.svg" alt="">
              <p class=" pl-4 truncate inline cursor-default" v-text="event.address" @click="showPopUp('address')"></p>
              <div v-if="event.address.length > 35" :class="{'popOnClickMobile': showAddressPopUp}"
                     class="absolute -mx-2 pin-t pin-l p-2 bg-white z-10 hidden cursor-default popOnHover shadow-lg rounded">
                <img class="w-4 h-4" src="@/assets//SVG/address.svg" alt="">
                <p class="pl-4" v-text="event.address"></p>
              </div>
            </div>
            <div class="flex items-center mt-3"><img class="w-4 h-4" src="@/assets//SVG/price.svg" alt="">
              <p class="font-bold  pl-4" v-text="`${event.price/100} ${event.currency || 'RUB'}`"></p>
            </div>
          </div>
          <div v-if="regIsDisabledByAllowedTeams || worksWithAllowedTeams && !userData.id" class="h-12 mt-4 flex">
            <img class="self-start pt-2" src="@/assets/icons/onlyTopTeamRegistrationIcon.svg" alt="onlyTopTeamRegistrationIcon.svg">
           <p class="pt-2 pl-4 text-brand-light text-sm font-bold leading-none">Регистрация доступна только топ-командам из рейтинга</p>
          </div>
          <div v-if="showCardInfoByAllowedTeams" class="h-12 mt-4">
            <h2 class="text-lg iphone-font pt-4"
                v-if="cardInfo.title">{{cardInfo.title}}</h2>
            <p v-if="cardInfo.sub_title" :class="buttonStatus.type === 'privileged_app_open' ?
             'text-sm' : 'text-mxs text-brand-light'" class="h-4 pt-1">{{cardInfo.sub_title}}</p>
            <p v-if="!cardInfo.sub_title && (buttonStatus.type === 'reg_closed' || buttonStatus.type === 'reg_closed_deny' ) "
               class="text-sm h-4 pt-2 pb-3">{{getRegistrationDate[0]}}</p>
            <div class="flex flex-row" v-if="buttonStatus.type=='cancel_res' ||
            buttonStatus.type=='cancel_reg' " @click="change_data = true">
              <button class="pt-1 h-4 text underline outline-none text-xs z-10 cursor-pointer">Изменить данные о команде</button>
            </div>
          </div>
          <div class="flex flex-row cursor-pointer pl-1 " v-if="places === 'few_places'">
            <img src="@/assets//SVG/exclamation-mark.svg" alt="">
            <button class="ml-3 text-red flex text-xs" :disabled="is_partner">Осталось мало мест</button>
          </div>
          <div class="button-box mb-4 text-center -m-1 items-center w-full pt-4 sm:mt-0">
            <button @click.prevent="tryToReg(buttonStatus.type)"
              :class="[buttonStatus.style]"
              class="h-10 w-full outline-none rounded-full font-semibold  text-sm"
              ref="tryreg"
              :disabled="openPayBefore === true || regStatus === 'reg_notbegin' || is_partner || regIsDisabledByAllowedTeams" v-if="buttonStatus.title">{{buttonStatus.title}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <participate v-if="participate && city_id" :city_id="city_id" :reg_type="registration_type" @close="participate = false" :user_events="user_events"
                 :privileged_team="privileged_team"
                 :allowed_teams="hasAllowedTeams"
                 :works-with-allowed-teams="worksWithAllowedTeams"
                 @isGameFree="setIsGameFree"
                 @there_are_places="participate = false; there_are_places=true" :participate="participate"
                 :gameCost="event.price" :event="event" @thanks="participate = false; thanks = true; thank_type='reg'"
                 @thanks_res="participate = false;thanks = true; thank_type='res'" @in_reserve="participate = false;reg_to_reserve=true"></participate>

    <cl-participate v-if="cl_participate && city_id" :city_id="city_id" :reg_type="registration_type" @close="cl_participate = false" :user_events="user_events"
              :privileged_team="privileged_team"
              :allowed_teams="hasAllowedTeams"
              :works-with-allowed-teams="worksWithAllowedTeams"
              @there_are_places="cl_participate = false; there_are_places=true" :participate="cl_participate"
              :gameCost="event.price" :event="event" @thanks="cl_participate = false; thanks = true; thank_type='reg'"
              @thanks_res="cl_participate = false;thanks = true; thank_type='res'"
              @in_reserve="cl_participate = false;reg_to_reserve=true"></cl-participate>

            <sing-up v-if="sing_up" @close="sing_up = false" @openLogin="sing_up = false; login=true" :login="login"
              @login="text_action='login'; text_modal = true; sing_up = false" :sing_up="sing_up"></sing-up>

            <login  v-if="login"
                    @close="login = false"
                    @openSingUp="login = false; sing_up=true"
                    :sing_up="sing_up"
                    @recovery_account="login = false; recovery_account=true" :recovery_account="recovery_account"
                    :login="login"
                    @loggedIn="userInfo()"></login>

            <new-password v-if="new_password" @close="new_password = false" :new_password="new_password"></new-password>

            <recovery-account v-if="recovery_account" @close="recovery_account = false"
              @restore_account="text_action='restore_account'; text_modal = true; recovery_account = false"
              :recovery_account="recovery_account"></recovery-account>

            <there-are-places v-if="false" @close="there_are_places = false"
              @pay_online="there_are_places = false; pay_online=true" :there_are_places="there_are_places">
            </there-are-places>

            <change-data v-if="change_data && city_id" :city_id="city_id" @thanks="change_data = false; thanks = true; thank_type='change'" @close="change_data = false" :team="is_in_user_events" :event="event"/>

            <change-data-msg  v-if="change_data_msg"
                              :name ="userData.name"></change-data-msg>

            <save v-if="save" @close="save = false" :save="save"></save>

            <refuse-to-participate v-if="refuse_to_participate" @close="refuse_to_participate = false"
              @paidTeam="text_action='paid'; text_modal = true; change_data = false"
              @notPaidTeam="text_action='not_paid'; text_modal = true; change_data = false"
              :refuse_to_participate="refuse_to_participate"></refuse-to-participate>

            <text-modal v-if="text_modal" @close="text_modal = false" :text_modal="text_modal"
              :text_action="text_action" />
            <thank-you v-if="thanks"
                       :isGameFree="isGameFree"
                       @close="closeThankYouModal" class="absolute z-50 flex"
              :woPay="!isCorporateGame"  :event="event" :reminder="reminder" :thank_type="thank_type"></thank-you>

            <remind-text v-if="remind_text" @close="remind_text = false; remind_type='';" class="absolute z-50 flex"
              :reminder="reminder" :remind_type="remind_type"></remind-text>

            <change-game-day v-if="change_game_day" @close="change_game_day=false;" @close_upd="change_game_day=false;" :event="event" :events="events" :user_in_line="user_in_line"  />

            <remind-about-registration v-if="remind_about_registration" @close="remind_about_registration = false"
              @applyRemind="applyRemind($event)"
              :remind_about_registration="remind_about_registration"></remind-about-registration>

            <reserve-reg v-if="reserve_reg && city_id" :city_id="city_id" @close="reserve_reg = false"
                         @thanks="reserve_reg = false; thanks = true; thank_type='res'"
              :event="event " :user_events="user_events"></reserve-reg>

            <reserve-thank-you-msg v-if="false"></reserve-thank-you-msg>
            <reg-cancel :cancel_type="cancel_type" v-if="reg_cancel" @close="reg_cancel = false"></reg-cancel>
            <reserve-cancel-question v-if="false"></reserve-cancel-question>
            <reserve-change-data v-if="false"></reserve-change-data>
            <!--  find team open telegram channel after cancel participate by user  -->
            <two-buttons-base-modal
                v-if="showFindTeamModal"
                :button1="{
                 text:'Нет, спасибо',
                 classes:'font-bold text-10px lg:text-lg py-2.5 lg:py-3 px-6 lg:px-7 border-2 rounded-full hover-up outline-none'
                }"
                :button2="{
                  text:'Найти команду',
                  classes:'font-bold text-10px lg:text-lg py-2.5 lg:py-3 px-6 lg:px-7 rounded-full bg-brand-yellow hover-up outline-none'
                 }"
                description="Не смогли собрать команду, но хотите сыграть - переходите в наш чат поиска команды в Telegram."
                @firstButtonClick="showFindTeamModal = false"
                @secondButtonClick="openTelegramChannel"
                @close="showFindTeamModal = false"
            >
              <div slot="title">
                <p class=" text-sm lg:text-lg font-bold text-main-text">
                  <span class="text-brand-light">{{userData.name}}</span>, заявка на игру от команды <span class="text-brand-light">{{registeredTeamName}}</span> отменена.</p>
              </div>
            </two-buttons-base-modal>

            <user-data-change-q v-if="false"></user-data-change-q>

            <reg-no-place @close="reg_to_reserve = false;  $emit('update_events')"   v-if="reg_to_reserve"></reg-no-place>

            <delete-modal key="delete_modal" :partners="false" v-if="delete_modal_reg" @close="delete_modal_reg = false"
              @white_button="removePlayDay('reg'); delete_modal_reg=false" @yellow_button=" delete_modal_reg = false"
              :text="'Вы уверены, что хотите \n отказаться от участия в игре?'" :button_text_firs="'Отменить запись'" :button_text_second="'Нет'"
              class="z-50 flex"></delete-modal>
            <delete-modal key="delete_modal_rez" :partners="false" v-if="delete_modal_res" @close="delete_modal_res = false"
              @white_button="removePlayDay('res'); delete_modal_res=false" @yellow_button="delete_modal_res = false "
              :text="'Вы уверены, что хотите \n отменить запись в резерве?'" :button_text_firs="'Отменить запись'" :button_text_second="'Нет'"
              class="z-50 flex"></delete-modal>
              <ask-modal-white  v-if="false"
                                @white_button="alert('ff')"
                                @yellow_button="alert()"
                                question = "Точно?"
                                />
    <modal
        @close="isRegistrationNotAllowed = false"
        v-if="isRegistrationNotAllowed"
        classes="mx-auto overflow-auto w-80 md:w-105 pt-0 shadow-none"
    >
      <div class="bg-white pt-10 pb-8 px-4 text-main-text font-Montserrat">
        <h2 class="text-lg md:text-xl leading-1.25 text-center">Регистрация невозможна</h2>
        <p class="mt-4 md:mt-6 text-center text-sm md:text-lg leading-1.5">Регистрация на данное мероприятие доступна только топ-командам из рейтинга.</p>
      </div>
    </modal>
  </div>
</template>

<script>
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import { mapActions, mapState } from 'vuex';
import ru from 'date-fns/locale/ru';
import player from '@/clients/player';
import twoButtonsBaseModal from '@/views/modals/two-buttons-base-modal.vue';
import Participate from '@/views/home-page-layouts/paymentModals/without-online-pay/wo-participate.vue';
import DeleteModal from '@/views/partners/events/order/delete-modal.vue';
import ThankYou from '../../thank-you.vue';
import ThereArePlaces from './there-are-places.vue';
import PayOnline from './pay-online.vue';
import ChangeData from './change-data.vue';
import ChangeDataMsg from './change-data-msg.vue';
import Save from './save.vue';
import RefuseToParticipate from './refuse-to-participate.vue';
import Error from './error.vue';
import RecoveryAccount from '../auth/recovery-account.vue';
import TextModal from './text-modal.vue';
import NewPassword from '../auth/new-password.vue';
import RemindAboutRegistration from './remind-about-registration.vue';
import SingUp from '../auth/sing-up.vue';
import Login from '../auth/login.vue';
import ReserveReg from './reserve/reserve-reg.vue';
import ReserveThankYouMsg from './reserve/reserve-thank-you-msg.vue';
import RegCancel from './reg-cancel-msg.vue';
import ReserveCancelQuestion from './reserve/reserve-cancel-question.vue';
import ReserveChangeData from './reserve/reserve-change-data.vue';
import ReserveReject from './reserve/reserve-reject.vue';
import RegNoPlace from './reg-no-place.vue';
import UserDataChangeQ from './without-online-pay/userdata-change-q.vue';
import CancelQuestion from './cancel-question.vue';
import AskModalWhite from './ask-modal-white.vue';
import RemindText from './remind-text.vue';
import ChangeGameDay from './change-game-day.vue';
import modal from '@/views/modals/new-base-modal.vue';
import ClParticipate from '@/views/home-page-layouts/paymentModals/corpLeague/cl-participate.vue';
import * as Cookies from 'js-cookie';

export default {
  name: 'Payment',
  props: {
    event: {
      type: Object,
    },
    user_events: {
      type: Array,
      default: [],
    },
    events: {
      type: Array,
    },
  },
  components: {
    Login,
    SingUp,
    RemindAboutRegistration,
    NewPassword,
    TextModal,
    RecoveryAccount,
    Error,
    RefuseToParticipate,
    Save,
    ChangeData,
    ChangeDataMsg,
    PayOnline,
    ThereArePlaces,
    ThankYou,
    Participate,
    ReserveReg,
    ReserveThankYouMsg,
    RegCancel,
    ReserveCancelQuestion,
    ReserveChangeData,
    ReserveReject,
    RegNoPlace,
    UserDataChangeQ,
    DeleteModal,
    CancelQuestion,
    AskModalWhite,
    RemindText,
    ChangeGameDay,
    ClParticipate,
    twoButtonsBaseModal,
    modal,
  },
  data() {
    return {
      isGameFree: false,
      showProfile: false,
      showCity: false,
      thanks: false,
      there_are_places: false,
      sing_up: false,
      change_data: false,
      change_data_msg: false,
      save: false,
      refuse_to_participate: false,
      text_modal: false,
      error: false,
      login: false,
      recovery_account: false,
      new_password: false,
      participate: false,
      openPayBefore: false,
      included_reserve: false,
      remind_about_registration: false,
      turn_on_remind: false,
      text_action: '',
      delete_modal_reg: false,
      delete_modal_res: false,
      reg_complete: false,
      reserve_reg: false,
      userdata_change_q: false,
      reg_cancel: false,
      reg_to_reserve: false,
      places: false,
      thank_type: '',
      cancel_type: '',
      reminder: {},
      remind_text: false,
      remind_type: '',
      change_game_day: false,
      tempr: '',
      registration_type: '',
      registration_closed: false,
      privileged_team: '',
      cl_participate: false,
      showFindTeamModal: false,
      registeredTeamName: null,
      showAddressPopUp: false,
      showPlacePopUp: false,
      isRegistrationNotAllowed: false,
    };
  },
  methods: {
    ...mapActions(['setToken', 'setUser', 'setGameId', 'removeUserApplication']),
    async tryToReg(type) {
      if (this.regIsDisabledByAllowedTeams) {
        this.isRegistrationNotAllowed = true;
        return
      }
      if (this.userData.id) {
        const safeType = await player.get('/me');
        type = this.buttonStatus.type;
      }
      if (Object.keys(this.userData).length == 0) {
        this.setGameId(this.event.uuid);
        Cookies.set('paymentGameId', this.event.uuid);
        this.login = true;
        return;
      }
      if (this.game_id) {
        this.setGameId(null);
      }
      if (Cookies.get('paymentGameId')) {
        Cookies.remove('paymentGameId');
      }
      if (this.regIsDisabledByAllowedTeams) {
        console.log('ggffgfdgddg');//todo modal here bavar
        return undefined;
      }
      // eslint-disable-next-line default-case
      switch (type) {
        case 'privileged_app_open':
        case 'app_open':
          this.registration_type = 'registration';
          if (this.isCorporateGame) {
            this.cl_participate = true;
          } else {
            this.participate = true;
          }
          break;
        case 'app_reserve':
          this.registration_type = 'reserve';
          if (this.isCorporateGame) {
            this.cl_participate = true;
          } else {
            this.participate = true;
          }
          break;
        case 'reg_closed':
          // this.remind_about_registration = true;
          break;
        case 'cancel_reg':
          this.delete_modal_reg = true;
          break;
        case 'cancel_res':
          this.delete_modal_res = true;
          break;
        case 'reg_closed_deny':
          this.denyRemind();
          break;
        case 'in_line':
          this.change_game_day = true;
          break;
        default:
          break;
      }
      if (this.user_events.length) {
        if (this.user_events.findIndex(item => item.games_event_day_id === this.event.uuid) > -1) {
          this.delete_modal = true;
          return undefined;
        }
      }
    },

    removePlayDay(type) {
      const appId = this.user_events.find(item => item.games_event_day_id === this.event.uuid).id;
      player.delete(`/applications/${appId}`)
        .then(() => {
          this.removeUserApplication(appId);
          if (this.city_id === 5) {
            // open modal cancel registration with option to open telegram channel only for city Yekaterinburg
            this.showFindTeamModal = true;
          } else {
            this.reg_cancel = true;
          }
          this.cancel_type = type;
        });
    },
    applyRemind(event) {
      this.remind_about_registration = false;
      this.reminder = event;
      this.turn_on_remind = true;
      this.remind_type = 'remind';
      this.remind_text = true;
    },
    denyRemind() {
      this.reminder = {};
      this.turn_on_remind = false;
      this.remind_type = 'remind_deny';
      this.remind_text = true;
    },
    change_registration_status() {
      this.registration_closed = false;
    },
    userInfo() {
      this.login = false;
      const route = this.city_id ? `/me?city_id=${this.city_id}` : '/me';
      player.get(route)
        .then(({
          data,
        }) => {
          this.setUser(data);
          if (data.role.toLowerCase() != 'player') return;
          this.$refs.tryreg.click();
        }).catch((e) => { console.log(e, 'error'); });
    },
    // to check if game is free or not
    setIsGameFree(option) {
      this.isGameFree = option;
    },
    getRegisteredTeamName() {
      const teamId = this.userData.applications.find(item => item.games_event_day_id === this.event.uuid).team_id;
      const userTeam = this.userData.teams.find(item => item.id === parseInt(teamId));
      this.registeredTeamName = userTeam.name;
      this.$emit('update_events');
    },
    closeThankYouModal() {
      if (this.city_id === 5) {
        this.getRegisteredTeamName();
      }
      this.thanks = false;
      this.$emit('update_events');
      this.thank_type = '';
    },
    openTelegramChannel() {
      window.open('https://t.me/joinchat/K65RCH0opTk2ZTI6?utm_source=offline&utm_medium=hypothesis');
      this.showFindTeamModal = false;
    },
    showPopUp(value) {
      console.log(value);
      if (value === 'address') {
        this.showAddressPopUp = true;
      } else if (value === 'place') {
        this.showPlacePopUp = true;
      }
    },
  },
  computed: {
    ...mapState({
      currency: state => state.user.cityProps.currency,
      game_id: state => state.auth.gameId,
      city_id: state => state.user.cityProps.id,
      userData: state => state.auth.user,
      token: state => state.auth.accessToken,

    }),
    regStatus() {
      const participate = this.user_events.findIndex(item => item.games_event_day_id === this.event.uuid && (item.status === 'active' || item.status === 'reserve')) > -1;
      this.places = !this.event.is_full;
      const isRegBegin = this.event.is_registration_opened;
      const isActive = this.user_events.find(item => item.games_event_day_id === this.event.uuid) ? this.user_events.find(item => item.games_event_day_id === this.event.uuid).status : '';

      if (!isRegBegin && !participate) {
        let team = '';
        if (this.userData.id) {
          team = [...this.event.team_ids_with_privileged_registration].filter(team => [...this.userData.teams].find(user_team => (user_team.id === team) && (user_team.city_id === this.city_id)))[0];
        }
        this.privileged_team = team;
        if (team && participate) return 'already_reg';
        return team ? 'privileged' : 'reg_notbegin';
      }
      if (participate && !this.places && isActive === 'reserve') {
        return 'already_reserv';
      } else if (participate && isActive === 'active') {
        return 'already_reg';
      } else if (!this.places) {
        return 'reserv';
      }
      return '';
    },
    worksWithAllowedTeams() {
      return this.event.works_with_allowed_teams && !this.event.ignores_allowed_teams_rule;
    },
    hasAllowedTeams() {
      let teams = [];
      if (this.userData.id && this.event.works_with_allowed_teams && !this.event.ignores_allowed_teams_rule) {
        console.log('allowed_team_ids', this.event.allowed_team_ids);
        teams = [...this.userData.teams].filter(userTeam => this.event.allowed_team_ids.includes(userTeam.id) && (userTeam.city_id === this.city_id));
      }
      return teams;
    },
    regIsDisabledByAllowedTeams() {
      if (this.userData.id) {
        return this.worksWithAllowedTeams && this.hasAllowedTeams.length === 0;
      }
      return false;
    },
    showCardInfoByAllowedTeams() {
      return !this.worksWithAllowedTeams || this.worksWithAllowedTeams && this.hasAllowedTeams.length > 0 && this.userData.id;
    },
    gameBanner() {
      if (this.event.media_banner.head) {
        return;
      }
      if (this.event.game_type === 'Классическая игра') {
        return 'classic-game';
      } else if (this.event.game_type === 'Тематическая') {
        return 'thematic-game';
      }
      return 'basic';
    },
    user_in_line() {
      return this.user_events.filter(item => item.games_event_record_id === this.event.event_record_id)[0];
    },
    is_in_one_line() {
      const tempAr = [];
      if (this.events) {
        this.events.forEach((item) => {
          if (item.event_record_id === this.event.event_record_id) {
            tempAr.push(item);
          }
        });
      }
      return tempAr.length > 1 ? this.event.event_record_id.slice(0, 6) : false;
    },
    is_in_user_events() {
      return this.user_events.filter(item => item.games_event_day_id === this.event.uuid)[0];
    },
    getGameType() {
      if (!this.event.game_topic && this.event.game_type) {
        return this.event.game_type;
      }
      if (this.event.game_topic && this.event.game_type) {
        return this.event.game_topic;
      }
      return {};
    },
    getGameSmallTitle() {
      if (this.event.product) {
        return this.event.product;
      }
      return null;
    },
    getEventDate() {
      const dates = [];
      dates.push(format(parse(this.event.played_at), 'DD MMMM, dd', { locale: ru }));
      return dates;
    },
    getEventTime() {
      return format(parse(this.event.played_at), 'HH:mm', { locale: ru });
    },
    getRegistrationDate() {
      const dates = [];
      dates.push(format(parse(this.event.registration_at), 'DD MMMM, HH:mm', { locale: ru }));
      return dates;
    },
    userEventStatus() {
      return {
        isParticipate: this.user_events.findIndex(item => item.games_event_day_id === this.event.uuid && item.status === 'active') > -1,
        isEventFull: !this.isParticipate ? this.event.is_full : null,
      };
    },

    buttonStatusPartner() {
      return {
        title: 'Текущая регистрация',
        style: 'bg-brand-light text-white hidden',
        type: 'app_open',
      };
    },

    buttonStatus() {
      const status = this.userEventStatus;

      if (this.is_in_one_line) {
        let user_event = {};
        const events_sub = [];
        this.events.forEach((item) => {
          if (item.event_record_id === this.event.event_record_id) {
            events_sub.push(item);
          }
        });

        this.user_events.forEach((item) => {
          if (item.games_event_day_id === this.event.uuid) {
            user_event = item;
          }
        });
        const idx = events_sub.findIndex(item => item.uuid === this.event.uuid);
        const active = this.user_events.filter(item => item.games_event_record_id === this.event.event_record_id);

        if (idx < 0 && status.isEventFull) {
          return {
            title: 'Запись в резерв',
            style: 'bg-brand-yellow text-main-text hover-up cursor-pointer',
            type: 'app_reserve',
          };
        }
        if (!Object.keys(user_event).length && !status.isEventFull && active.length) {
          return {
            title: 'Сыграть в этот день',
            style: 'bg-brand-light text-white hover-up cursor-pointer',
            type: 'in_line',
          };
        }
      }

      if (this.regStatus === 'already_reserv') {
        return {
          title: 'Отказаться от участия',
          style: 'bg-white border border-additional-text text-main-text hover-up cursor-pointer',
          type: 'cancel_res',
        };
      }

      if (this.regStatus === 'privileged') {
        return {
          title: 'Зарегистрироваться',
          style: 'bg-brand-light text-white hover-up cursor-pointer',
          type: 'privileged_app_open',
        };
      }


      if (this.regStatus === 'already_reg') {
        return {
          title: 'Отказаться от участия',
          style: 'bg-white border border-additional-text text-main-text hover-up cursor-pointer',
          type: 'cancel_reg',
        };
      }
      if (this.regStatus === 'reg_notbegin') {
        return {
          title: 'Зарегистрироваться',
          style: 'bg-additional-text text-white',
          type: 'reg_closed',
        };
      }

      if (status.isEventFull) {
        return {
          title: 'Запись в резерв',
          style: 'bg-brand-yellow text-main-text hover-up cursor-pointer',
          type: 'app_reserve',
        };
      }
      if (this.openPayBefore === true || this.regStatus === 'reg_notbegin' || this.is_partner || this.regIsDisabledByAllowedTeams) {
        return {
          title: 'Зарегистрироваться',
          style: 'bg-grey text-white cursor-default',
          type: 'app_open',
        };
      }
      if (!status.isParticipate && !status.isEventFull) {
        return {
          title: 'Зарегистрироваться',
          style: 'bg-brand-light text-white hover-up cursor-pointer',
          type: 'app_open',
        };
      }
    },
    is_partner() {
      return !!(this.userData.role === 'editor' || this.userData.role === 'partner' || this.userData.role === 'event_organizer');
    },


    isCorporateGame() {
      return this.event.product.toLowerCase().includes('корпоративная лига');
    },
    cardInfo() {
      switch (this.buttonStatus.type) {
        case 'in_line':
          return {
            title: 'Регистрация уже идет',
            sub_title: 'Ваша команда уже принимает участие в этой серии игр. Хотите поменять дату или место мероприятия?',
          };
          break;
        case 'in_line_reserve':
          return {
            title: 'Места закончились',
            sub_title: 'Ваша команда уже принимает участие в этой серии игр. Хотите поменять дату или место мероприятия?',
          };
          break;
        case 'cancel_res':
          return {
            title: 'Вы записаны в резерв',
          };
          break;
        case 'cancel_reg':
          return {
            title: 'Вы зарегистрированы',
          };
          break;
        case 'reg_closed':
          return {
            title: 'Регистрация откроется',
          };
          break;
        case 'reg_closed_deny':
          return {
            title: 'Регистрация откроется',
          };
          break;
        case 'app_reserve':
          return {
            title: 'Регистрация в резерв',
            sub_title: 'Организаторы сообщат вам, если место освободится.',
          };
          break;
        case 'app_open':
          return {
            title: 'Регистрация уже идет',
          };
          break;
        case 'privileged_app_open':
          return {
            title: 'Льготная регистрация открыта',
            sub_title: `до ${format(parse(this.event.registration_at), 'DD MMMM/ HH:mm', { locale: ru })}`,
          };
        default:
          break;
      }
    },
  },
  watch: {
    turn_on_remind() {
      return this.turn_on_remind;
    },
    'event.is_registration_opened': function (n, o) {
      console.log(n, o, 'WATCHOVER');
      if (this.event.is_registration_opened) {
        this.privileged_team = '';
      }
    },
    token() {
      const gameId = Cookies.get('paymentGameId');
      if (this.$route.params.provider && gameId) {
        if (this.event.uuid == gameId) {
          this.userInfo();
        }
      }
    },
  },
};
</script>

<style scoped>

.card {
  box-sizing: content-box;
  margin-bottom: 1.5rem;
}
.thematic-game {
  background-image: url('../../../assets/film_and_music.png');
  background-size: cover;
  background-repeat: no-repeat
}
.classic-game {
  background-image: url('../../../assets/classic.png');
  background-size: cover;
  background-repeat: no-repeat
}
.basic {
  @apply bg-brand-darker;
}
.item {
  height: auto;
}
.button-box {
  box-sizing: border-box;
}

.truncate:hover + .popOnHover {
  display: flex !important;
}

.popOnHover:hover {
  display: flex !important;
}

.popOnClickMobile {
  display: flex !important;
}

@media only screen and (min-width: 319px) and (max-width: 330px) {
  .card {
    box-sizing: content-box;
  }
}

@media only screen and (min-width: 400px) and (max-width: 600px) {
  .card {
    box-sizing: content-box;
  }
}
@media only screen and (min-width: 330px) and (max-width: 400px) {
  .card {
    box-sizing: border-box;
  }
}

@media only screen and (min-width: 600px) {
  .card {
    box-sizing: content-box;
}
}
@media only screen and (min-width: 768px) {
  .card {
    box-sizing: content-box;
  }
}

@media only screen and (min-width: 992px) {
  .card {
    box-sizing: content-box;
  }
}

@media only screen and (min-width: 1200px) {
  .card {
    box-sizing: content-box;
  }
}
</style>
